import Vue from 'vue';
import App from './App.vue';
import router from './router';

// import Datatable from 'vue2-datatable-component'
// Vue.use(Datatable);

// import query from "query";
// Vue.use(query);

// VUE SELECT
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

// VEE VALIDATE
import VeeValidate, { Validator } from "vee-validate"
Vue.use(VeeValidate, {
  useConstraintAttrs: true
});
// import es from 'vee-validate/dist/locale/es'
// Validator.localize("es", es);



import VueSession from 'vue-session'
Vue.use(VueSession);

import VueExpandableImage from 'vue-expandable-image'
Vue.use(VueExpandableImage);

import VueAlertify from 'vue-alertify';
Vue.use(VueAlertify);

import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import './assets/static';
//import './assets/scss/main.scss';

// Others


library.add(fas);
library.add(fab);
library.add(far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.mixin({
  data: function() {
    return {
      opencall_view: true
    }
  }
});

// new Vue({
//   el: "#app",
//   router,
//   render: h => h(App),
  
// });


 

new Vue({
  router,
  render: function (h) {
    return h(App);
  },
}).$mount('#app');